import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { HeroUIProvider } from "@heroui/react";
import Main from "./components/container/Main";
import CommonLayoutAuth from "./components/helper/Interceptor";
import SocketContextProvider from "./context/SocketContext";
import "react-toastify/dist/ReactToastify.css";
const BASENAME = process.env.REACT_APP_BASENAME;

function App() {
  useEffect(() => {
    CommonLayoutAuth();
  }, []);

  return (
    <HeroUIProvider>
      <div>
        <BrowserRouter basename={BASENAME}>
          <SocketContextProvider>
            <Main />
          </SocketContextProvider>
          <ToastContainer
            autoClose={3000}
            position="top-right"
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            toastClassName="rc-toast"
            bodyClassName="rc-toast-body"
            theme="colored"
          />
        </BrowserRouter>
      </div>
    </HeroUIProvider>
  );
}

export default App;
